const SvgSupplyChain3 = (props) => (
  <>
    <circle cx={96} cy={96} r={96} fill="none" stroke={props.p30} strokeMiterlimit={10} />
    <circle cx={96} cy={96} r={48} fill="none" stroke={props.p30} strokeMiterlimit={10} />
    <path
      d="M100 0c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4ZM100 48c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4ZM100 144c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4ZM100 192c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4Z"
      fill={props.p30}
    />
    <circle cy={96} r={4} fill={props.p30} />
    <circle cx={48} cy={96} r={4} fill={props.p30} />
    <circle cx={144} cy={96} r={4} fill={props.p30} />
    <circle cx={192} cy={96} r={4} fill={props.p30} />
  </>
);

export default SvgSupplyChain3;
